import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-puzzle-surface border-t border-puzzle-border">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <p className="text-center text-sm text-puzzle-text-secondary">
          {`© ${currentYear} Puzzlists`}
          <span className="mx-2">•</span>
          <Link to="/about" className="hover:text-puzzle-text">About</Link>
          <span className="mx-2">•</span>
          <Link to="/how-it-works" className="hover:text-puzzle-text">How It Works</Link>
          <span className="mx-2">•</span>
          <Link to="/whats-new" className="hover:text-puzzle-text">What&apos;s New</Link>
          <span className="mx-2">•</span>
          <Link to="/terms" className="hover:text-puzzle-text">Terms</Link>
          <span className="mx-2">•</span>
          <Link to="/privacy" className="hover:text-puzzle-text">Privacy</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
